<script>
import FormElements from "@wielink-application/shared/js/mixins/formElements";
import Changes from "@wielink-application/shared/js/mixins/changes";
import {Link, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";

export default {
  components: {Link, Card},
  mixins: [FormElements, Changes],
  data() {
    return {
      productTesterTypesOptions: [],
      priceBundle: {
        product_tester_types: []
      },
      form: useForm({
        title: '',
        external_id: '',
        product_tester_types: [],
        discount_amount: 0
      })
    }
  },
  methods: {
    setPriceBundle(price_bundle) {
      this.priceBundle = price_bundle;

      this.productTesterTypesOptions = price_bundle.product_tester_types.map(type => {
        return {
          label: type.name,
          value: type.id,
        }
      })
      this.priceBundle.product_tester_types = this.priceBundle.product_tester_types.map(type => type.id) ?? [];

      this.form.defaults(this.priceBundle);
      this.form.reset();
      this.form.isDirty = false;
    },
  }
}
</script>

<template>
  <div class="row g-4">
    <div class="col-xl-6">
      <Card class="h-100">
        <h2 class="card-title">Details</h2>

        <Input
            :form="form"
            v-model="form.title"
            name="title"
            :required="true"
            label="Titel"
        />

        <Price
            :form="form"
            v-model="form.discount_amount"
            name="discount_amount"
            label="Korting"
        />

        <Select
            v-model="form.product_tester_types"
            groupClasses="mb-0"
            name="product_tester_types"
            label="Meetmiddelen"
            :form="form"
            :multiple="true"
            :options="productTesterTypesOptions"
            :ajaxUrl="route('api.v1.products.tester_types.list')"
        />
      </Card>
    </div>
  </div>

</template>